// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"DropdownMenu_dropdown__h42kr","menu":"DropdownMenu_menu__jSbV0","menuItem":"DropdownMenu_menuItem__jm44j"};